import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const VALUES = [
  "Epoxidharzböden",
  "Bodenbeschichtungen",
  "Hausmeisterservice",
  "Gebäudereinigung",
  "Pflasterreinigung",
  "Privat & Gewerbe",
  "Faire Preise",
];

export const About = () => (
  <section id="ueber-uns" data-testid="about-section" className="bg-white text-ink py-24 md:py-36">
    <div className="mx-auto max-w-7xl px-5 md:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
      >
        <p className="mb-4 text-xs font-bold tracking-[0.3em] text-brand-dark">ÜBER UNS</p>
        <h2 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tighter leading-[1.05] hyphens-auto">
          Ihr Partner vor Ort –<br />
          <span className="text-black/40">mit Handschlag&shy;qualität.</span>
        </h2>
        <p className="mt-8 text-base md:text-lg leading-relaxed text-black/60">
          Die Terbeck Service GbR ist Ihr regionaler Fachbetrieb für hochwertige
          Bodenbeschichtungen und Gebäudeservice in Gronau (Westf.) und Umgebung im Kreis
          Borken. Unser Schwerpunkt sind Epoxidharzböden für Garage, Keller, Werkstatt und
          Gewerbe – ergänzt durch Hausmeisterservice, Gebäudereinigung und Pflasterreinigung.
        </p>
        <p className="mt-5 text-base md:text-lg leading-relaxed text-black/60">
          Wir arbeiten für Privat- und Gewerbekunden: zuverlässig, sauber und mit schneller,
          persönlicher Kommunikation. Unsere Angebote sind fair und transparent – ohne versteckte
          Kosten. Als regionales Unternehmen sind wir nah an unseren Kunden und flexibel in der
          Umsetzung.
        </p>
        <ul className="mt-8 flex flex-wrap gap-2.5">
          {VALUES.map((v) => (
            <li
              key={v}
              className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-black/[0.03] px-4 py-2 text-xs font-bold tracking-wide text-black/70"
            >
              <Check className="h-3.5 w-3.5 text-brand-dark" />
              {v}
            </li>
          ))}
        </ul>
        <button
          data-testid="about-cta-button"
          onClick={() => scrollToId("kontakt")}
          className="mt-10 rounded-full bg-ink px-8 py-4 text-sm font-bold tracking-wider text-white hover:bg-brand hover:text-black transition-colors duration-300"
        >
          KONTAKT AUFNEHMEN
        </button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="relative"
      >
        <div className="absolute -top-4 -left-4 h-full w-full rounded-2xl border-2 border-brand" aria-hidden="true" />
        <img
          src="/assets/img/objektbetreuung-modernes-wohnhaus-gronau.jpg"
          alt="Gepflegtes modernes Wohnhaus im Sonnenlicht – Objektbetreuung und Immobilienpflege durch Terbeck Service, Gronau (Westf.)"
          className="relative rounded-2xl object-cover w-full h-[420px] md:h-[560px]"
          loading="lazy"
        />
        <img
          src="/assets/terbeck-logo.jpeg"
          alt="Terbeck Service GbR Logo – Hausmeisterservice Gronau"
          className="absolute -bottom-8 -right-4 lg:-right-8 h-24 w-24 md:h-32 md:w-32 rounded-2xl object-cover shadow-2xl ring-1 ring-black/10"
          loading="lazy"
        />
      </motion.div>
    </div>
  </section>
);
